/**
 * Canonical destinations for routes that have no standalone page.
 * Lists are managed from the profile — `/lists` redirects here.
 */
export const LISTS_CANONICAL_PATH = "/profile?tab=lists";
export const WISHLIST_PATH = "/wishlist";
